import React, { useEffect, useState } from 'react'
import { CommonAjaxGetRequestWithOutParams } from '../Api/CommonAjaxUtils'
import { BASE_URL } from '../Api/APIURLS'
import * as HERBUI from 'react-bootstrap'
function ApgliPendingPopUp({ showpopup, handleClose }) {
    const [employeeddocount, setEmpDDoCount] = useState([])
    useEffect(() => {
        if (showpopup) {
            CommonAjaxGetRequestWithOutParams(BASE_URL + 'apgli/get/ddo/pendingFiles').then((response) => {
                if (response !== '' && response !== null && response !== undefined) {
                    setEmpDDoCount(response)
                }
            })
        }
    }, [showpopup])
    return (
        <div>
            <HERBUI.Modal size='lg' show={showpopup}
                onHide={handleClose}
                scrollable={true}>
                <HERBUI.Modal.Header className="modal-header">
                    <HERBUI.Modal.Title>
                        <h5> Pending Apgli Applications Alert <span style={{ color: "yellow" }}>⚠</span></h5>
                    </HERBUI.Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>
                </HERBUI.Modal.Header>
                <HERBUI.Modal.Body className="modal-body" >
                    <HERBUI.Row >
                        <HERBUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></HERBUI.Col>
                        <HERBUI.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                            <table
                                className="table table-bordered table-hover table-sm"
                                style={{
                                    fontSize: "13px",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    textAlign: "center",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
                                }}
                            >
                                <thead style={{ background: "#1E3770", color: "#fff", fontWeight: "600" }}>
                                    <tr>
                                        <th style={{ width: "10%" }}>S.No</th>
                                        <th style={{ textAlign: "left", width: "30%" }}>Request Type</th>
                                        <th style={{ width: "30%" }}>Pending at DDO</th>
                                        <th style={{ width: "30%" }}>Pending at Employee</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(
                                        !employeeddocount ||
                                        !employeeddocount?.pendingAtDdo?.length ||
                                        !employeeddocount?.pendingAtEmp?.length
                                    ) ? (
                                        <tr>
                                            <td colSpan="4" style={{ padding: "12px", fontWeight: "600" }}>
                                                No data found
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            <tr>
                                                <td>1</td>
                                                <td style={{ textAlign: "left" }}>Loans</td>
                                                <td>{employeeddocount.pendingAtDdo[0]?.loans ?? "---"}</td>
                                                <td>{employeeddocount.pendingAtEmp[0]?.loans ?? "---"}</td>
                                            </tr>

                                            <tr>
                                                <td>2</td>
                                                <td style={{ textAlign: "left" }}>Claims</td>
                                                <td>{employeeddocount.pendingAtDdo[0]?.claims ?? "---"}</td>
                                                <td>{employeeddocount.pendingAtEmp[0]?.claims ?? "---"}</td>
                                            </tr>

                                            <tr>
                                                <td>3</td>
                                                <td style={{ textAlign: "left" }}>Proposals</td>
                                                <td>{employeeddocount.pendingAtDdo[0]?.proposals ?? "---"}</td>
                                                <td>{employeeddocount.pendingAtEmp[0]?.proposals ?? "---"}</td>
                                            </tr>

                                            <tr>
                                                <td>4</td>
                                                <td style={{ textAlign: "left" }}>Policy Holder Requests</td>
                                                <td>{employeeddocount.pendingAtDdo[0]?.policyHolderReqs ?? "---"}</td>
                                                <td>{employeeddocount.pendingAtEmp[0]?.policyHolderReqs ?? "---"}</td>
                                            </tr>

                                            <tr>
                                                <td>5</td>
                                                <td style={{ textAlign: "left" }}>Beneficiary Updation Files</td>
                                                <td>{employeeddocount.pendingAtDdo[0]?.beneficiaryUpdation ?? "---"}</td>
                                                <td>{employeeddocount.pendingAtEmp[0]?.beneficiaryUpdation ?? "---"}</td>
                                            </tr>

                                            <tr>
                                                <td>6</td>
                                                <td style={{ textAlign: "left" }}>Nominee Correction at Employee</td>
                                                <td>{employeeddocount.pendingAtDdo[0]?.nomineeUpdation ?? "---"}</td>
                                                <td>{employeeddocount.pendingAtEmp[0]?.nomineeUpdation ?? "---"}</td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>

                        </HERBUI.Col>

                    </HERBUI.Row>


                </HERBUI.Modal.Body>
                <HERBUI.Modal.Footer className="modal-footer">
                    <HERBUI.Button className="btnClose btn-sm" onClick={handleClose}><b>Close </b></HERBUI.Button>
                </HERBUI.Modal.Footer>
            </HERBUI.Modal>
        </div>
    )
}

export default ApgliPendingPopUp